import { type ReactNode, useCallback, useState } from 'react'

import { IconCopy } from '@tabler/icons-react'
import copy from 'clipboard-copy'

import { ButtonIcon } from '@subaio/webapp'

import { useSnackbar } from 'components/Snackbars'

import { ButtonText } from './ButtonText'
import { Container } from './Container'
import { Label } from './Label'

type Props = {
	label: ReactNode
	value: string | (() => Promise<string>)
	onClick?: () => void
}

export const StaticField = ({ label, value }: Props) => {
	const { showSnackbar } = useSnackbar()
	const [isRevealed, setIsRevealed] = useState(typeof value === 'string')
	const [valueToShow, setValueToShow] = useState({
		value: typeof value === 'string' ? value : 'very secret value, trust us',
		isResolved: typeof value === 'string',
	})

	const getValue = useCallback(async () => {
		if (typeof value === 'string') {
			setValueToShow({ value, isResolved: true })
			return value
		}

		const result = await value()
		setValueToShow({ value: result, isResolved: true })
		return result
	}, [value])

	return (
		<div>
			<Label>{label}</Label>
			<Container>
				{typeof value === 'string' ? (
					valueToShow.value
				) : (
					<ButtonText
						isSpoiler={!isRevealed}
						onClick={async () => {
							if (valueToShow.isResolved === false) {
								await getValue()
								setIsRevealed(true)
							} else {
								setIsRevealed((isRevealed) => !isRevealed)
							}
						}}
					>
						{valueToShow.value}
					</ButtonText>
				)}
				<ButtonIcon
					icon={<IconCopy />}
					onClick={async () => {
						if (valueToShow.isResolved === false) {
							const value = await getValue()
							return copy(value)
						}

						showSnackbar({ message: 'Copied to your clipboard' })
						return copy(valueToShow.value)
					}}
				/>
			</Container>
		</div>
	)
}
